import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";

@Component({
    selector: 'child-cell',
    template: `
    <div class="grid-button-holder">
        <button type="button" class="btn btn-outline-danger btn-sm" (click)="invokeParentMethod('cancel')" *ngIf="cancelable">
            Cancel
        </button>
        <button type="button" class="btn btn-outline-success btn-sm" (click)="invokeParentMethod('status')" *ngIf="payment_trans">
            Status
        </button>
        <button type="button" class="btn btn-outline-danger btn-sm" (click)="invokeParentMethod('refund')" *ngIf="refundable">
            Refund
        </button>
        <a class="btn btn-secondary btn-sm" (click)="invokeParentMethod('view')" *ngIf="entity?.detail_page">
            <i class="fa fa-arrows-alt"></i>
        </a>
        <a class="btn btn-secondary btn-sm" (click)="invokeParentMethod('moveup')" *ngIf="entity?.maintain_sortorder">
            <i class="fa fa-arrow-up"></i>
        </a>
        <a class="btn btn-secondary btn-sm" (click)="invokeParentMethod('movedown')" *ngIf="entity?.maintain_sortorder">
            <i class="fa fa-arrow-down"></i>
        </a>
        <a class="btn btn-secondary btn-sm" (click)="invokeParentMethod('peek')" *ngIf="entity?.peekable">
            <i class="fa fa-eye"></i>
        </a>
        <a class="btn btn-secondary btn-sm" (click)="invokeParentMethod('action')" *ngIf="entity?.enable_custom_action">
            <i class="fa fa-random"></i>
        </a>
        <a class="btn btn-secondary btn-sm" (click)="invokeParentMethod('edit')" *ngIf="entity?.editable">
            <i class="fa fa-pencil"></i>
        </a>
        <a class="btn btn-secondary btn-sm" (click)="invokeParentMethod('delete')" *ngIf="entity?.deletable">
            <i class="fa fa-trash-o text-danger"></i>
        </a>
    </div>
`,

    styles: [
        `.btn-sm {
            padding:3px;                      
        }
        .grid-button-holder{
            padding:0px;
            margin-left:-22px;
        }`
    ]
})

export class GridButtonsComponent implements ICellRendererAngularComp {
    public params: any;
    public entity: any;
    public payment_trans: boolean = false;
    public refundable: boolean = false;
    public cancelable: boolean = false;

    agInit(params: any): void {
        // console.log('params', params);
        this.params = params;
        this.entity = params.data;
        if (this.entity && this.entity.entityId == "591d33c135ccd801c1b44ec3") { // payment transaction
            this.payment_trans = true;
            if (this.entity.data.status != "OPEN" && this.entity.data.status != "CREATED" && this.entity.data.status != "ERROR" && this.entity.data.status != "TXN_FAILURE" && this.entity.data.status != "FAILURE" && this.entity.data.status != "FAILED" && this.entity.data.status != "txn_failure" && this.entity.data.status != "REFUNDED" && this.entity.data.status != "refunded" && (!this.entity.data.refundattempts || (Array.isArray(this.entity.data.refundattempts) && this.entity.data.refundattempts.length == 0))) {
                this.refundable = true;
            }
        } else if (this.entity && this.entity.entityId == "5825d66df009c4bc37fd7bae" && this.entity.data.orderstatus != "cancelled" && this.entity.data.orderstatus != "paid-and-cancelled") { // food order
            this.cancelable = true;
        }
    }

    public invokeParentMethod(action) {
        this.params.buttonaction = action;
        this.params.context.componentParent.methodFromParent(this.params)
    }

    public refund() {

    }

    refresh(): boolean {
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/components/widgets/grid-list/grid-buttons.component.ts